// List of event names which will be sent to footprints api instead of mixpanel
export const FootprintsEvents = ['Viewed Online Store', 'Viewed Offer Page'];
